<!--
 * @Description  : 单项工程特殊处理页面
 * @Author       : 王帅
 * @Date         : 2024-08-24 10:02:57
 * @LastEditors  : 王帅
 * @LastEditTime : 2024-12-05 11:46:16
 * @FilePath     : \analysis_audit_admin\src\views\project-management\project-info\components\right_structure_unit.vue
-->
<template>
	<div class="right-main" v-loading="pageLoading">
		<el-tabs v-model="activeName" @tab-click="handleTabChange">
			<el-tab-pane label="工程内容" name="baseInfo">
				<div class="w-page-main">
					<div class="w-page-header">
						<div class="left-text"></div>
						<div class="btnGroups">
							<!-- 展开层级 -->
							<el-select v-model="curLevel" class="select-width" placeholder="请选择" size="small" @change="onChangeLevel">
								<el-option v-for="(m, n) in levelList" :key="'level' + n" :value="m.value" :label="m.sname"></el-option>
							</el-select>
							<!-- 按钮 -->
							<el-button type="primary" size="small" class="ml10" @click="showCheckbox = !showCheckbox" v-if="hasSubmit !== 1 && !hideBtn">{{
								!showCheckbox ? '解锁' : '锁定'
							}}</el-button>
							<el-button type="success" size="small" v-if="showCheckbox && hasSubmit !== 1" :loading="btnLoading" @click="doSave(0)"
								>保存</el-button
							>
							<el-button type="primary" size="small" v-if="showCheckbox && hasSubmit !== 1" :loading="btnLoading" @click="doSave(1)"
								>提交</el-button
							>
						</div>
					</div>
					<div class="w-page-container">
						<vxe-table
							border
							ref="xGrid"
							height="100%"
							resizable
							auto-resize
							show-overflow
							row-id="id"
							:data="tableData"
							:loading="loading"
              :tree-config="{ transform: false }"
							:checkbox-config="{ labelField: '', checkField: 'isChecked', checkRowKeys: expandKeys, highlight: true }"
						>
							<vxe-column type="checkbox" width="60" align="center" v-if="showCheckbox"></vxe-column>
							<vxe-column type="seq" title="序号" width="100"></vxe-column>
							<vxe-column field="sname" title="节点名称" tree-node min-width="220"></vxe-column>
							<vxe-column field="nodeTypeName" title="结构" min-width="150"></vxe-column>
							<vxe-column field="nodeCodeName" title="节点类型" min-width="130"></vxe-column>
						</vxe-table>
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="工程特征" name="1065001">
				<unit-fields :templateList="curBlockList" @onSuccess="handleTabChange" :hideBtn="hideBtn"></unit-fields>
			</el-tab-pane>
			<el-tab-pane label="技术指标" name="1065002">
				<unit-fields :templateList="curBlockList" @onSuccess="handleTabChange" :hideBtn="hideBtn"></unit-fields>
			</el-tab-pane>
			<el-tab-pane label="经济指标" name="1065003">
				<unit-fields :templateList="curBlockList" @onSuccess="handleTabChange" :hideBtn="hideBtn"></unit-fields>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import { getProFieldsAndValue } from '@/api/modules/analysis'
import unitFields from './unit_fields'
export default {
	name: '',
	props: {
		// loading
		pageLoading: {
			type: Boolean,
			default: false
		},
		// 接口返回的数据
		resData: {
			type: Object,
			default: () => {
				return {
					maxLevel: 2,
					treeArr: [],
					hasSubmit: 0
				}
			}
		},
		// 当前节点id
		curRowId: {
			type: String,
			default: ''
		},
		// 单项工程类型
		temType: {
			type: String,
			default: ''
		},
		// 是否显示操作按钮
		hideBtn: {
			type: Boolean,
			default: false
		}
	},
	components: {unitFields },
	data() {
		return {
			activeName: 'baseInfo',
			btnLoading: false,
			// 第一个tab
			curLevel: 2,
			loading: false,
			maxLevel: 1,
			staticData: [],
			tableData: [],
			expandKeys: [],
			tableH: 0,
			showCheckbox: false,
			checkAll: false,
			hasSubmit: 1,
			// 其它tab
			curBlockList: [],
			isDisabled: true
		}
	},
	methods: {
		// 渲染树结构数据
		initData(data) {
			this.tableData = this.$utils.clone(data, true)
			this.staticData = this.$utils.clone(data, true)

			// 默认展开一级
			this.onChangeLevel(2)
		},
		// 展开层级change
		onChangeLevel(level) {
			// 找到对应层级的数组
			let arr = this.$utils.filterTree(this.tableData, (x) => x.level <= level)
			if (this.$refs.xGrid) {
				// 先关闭所有
				this.$refs.xGrid.clearTreeExpand()
				this.$refs.xGrid.setTreeExpand(arr, true)
			}
		},

		/******* 提交、保存 *********/
		doSave(type) {
			this.btnLoading = true

			if (type === 1) {
				this.$confirm('提交后不可修改，确定提交吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						this.$emit('doSave', { type, arr: this.tableData })
					})
					.catch((err) => {
						setTimeout(() => {
							this.btnLoading = false
						}, 2000)
						return false
					})
			} else {
				this.$emit('doSave', { type, arr: this.tableData })
			}
		},
		// 接口完成回调
		handleCallBack(type, saveType) {
			setTimeout(() => {
				this.btnLoading = false
			}, 2000)
			switch (type) {
				case 'success':
					let msg = saveType === 0 ? '保存成功！' : '提交成功！'
					this.$message.success(msg)

					this.showCheckbox = false
					if (saveType === 1) {
					}
					break
				case 'error':
					break
			}
		},

		/******** 切换tab *******/
		handleTabChange(item) {
			switch (this.activeName) {
				case 'baseInfo':
					break
				default:
					let params = {
						projectId: this.curProjectId,
						temType: this.temType,
						tabType: this.activeName,
						nodeId: this.curRowId
					}
					getProFieldsAndValue(params)
						.then((res) => {
							this.curBlockList = res.data.blockList || []
						})
						.catch((err) => {})
			}
		}
	},
	computed: {
		// 展开层级数组
		levelList() {
			let strArr = [
				{ value: 0, sname: '展开到一级' },
				{ value: 1, sname: '展开到二级' },
				{ value: 2, sname: '展开到三级' },
				{ value: 3, sname: '展开到四级' },
				{ value: 4, sname: '展开到五级' },
				{ value: 5, sname: '展开到六级' },
				{ value: 6, sname: '展开到七级' },
				{ value: 7, sname: '展开到八级' },
				{ value: 8, sname: '展开到九级' },
				{ value: 9, sname: '展开到十级' }
			]
			let list = strArr.slice(0, this.maxLevel)
			return list
		},

		// 当前项目ID
		curProjectId() {
			return this.$route.query.projectId
		},

		// 工程特征字段列表
		blockList1() {
			return []
			// let item = this.blockList.find(x => x.blockType == )
		}
	},
	watch: {
		// 监听接口返回的数据
		resData: {
			handler: function(obj) {
				this.showCheckbox = false
				this.maxLevel = obj.maxLevel || 1
				this.curLevel = this.maxLevel >= 2 ? 2 : 0
				this.activeName = 'baseInfo'

				if (obj.treeArr && obj.treeArr.length > 0) {
					this.initData(obj.treeArr)
				} else {
					this.tableData = []
				}

				// 是否已提交
				this.hasSubmit = obj.hasSubmit
			},
			deep: true
		}
	}
}
</script>
<style scoped lang="less">
.right-main {
	height: 100%;
}
</style>
